
// State Object for Product_groupsCatalog. Dont directly mutate it anywhere except the product_groups/mutations.js file
export const product_groupsCatalogState = {
  product_groupsCatalogData: null,
  product_groupsList: null,
  product_groupDetails: null,
}


